module.exports = __webpack_public_path__ + "img/car_06.9df59507.jpg";